import { message } from "antd";
import { get, getById, getWithParams, patch } from "./base";

const getPatientDemographics = async () => {
  try {
    const response = await get("/Pacientes", true);
    return response.data;
  } catch (error) {
    throw new Error("Error fetching patient demographics:", error);
  }
};

const getPatientClinicResults = async (afiliado) => {
  try {
    const response = await get(`/DatosClinicos?afiliado=${afiliado}`, true);
    return response.data;
  } catch (error) {
    throw new Error("Error fetching ResultadosClinicos:", error);
  }
};

const getPlanesCuidadoResults = async (affiliate) => {
  try {
    const response = await getById("/PlanesCuidado?Afiliado=", affiliate);
    return response.data;
  } catch (error) {
    throw new Error("Error fetching PlanesCuidado:", error);
  }
};

const getCitasResults = async (
  gestor = null,
  afiliado = null,
  status,
  anio,
  tipo
) => {
  try {
    const queryParams = {
      gestor: gestor !== null ? gestor : "",
      afiliado: afiliado !== null ? afiliado : "",
      estatus: status,
      tipo: tipo !== null ? tipo : "2",
      anio: anio !== null ? anio : "",
    };
    const response = await getWithParams(
      `/PlanesCuidado/actividades`,
      queryParams
    );
    return response.data;
  } catch (error) {
    throw new Error("Error fetching getCitasResults:", error);
  }
};

const getGestoresResults = async (data) => {
  try {
    const response = await get(`/Gestores?EsMismoPss=${data}`, true);

    return response.data;
  } catch (error) {
    throw new Error("Error fetching Gestores:", error);
  }
};

export const getComorbilidades = async (afiliado) => {
  try {
    const response = await get(
      `/DatosClinicos/comorbilidades?afiliado=${afiliado}`
    );
    const data = await response.data;

    return data;
  } catch (error) {
    console.error("Error obteniendo comorbilidades:", error);
  }
};

const actualizarMedicamento = async (id, estatus) => {
  try {
    const data = { estatus: estatus };
    const response = await patch(`/Medicamentos/yo?id=${id}`, data);
    return response.data;
  } catch (error) {
    throw new Error("Error actualizando medicamento:", error);
  }
};

const actualizarComorbilidad = async (id, data) => {
  try {
    const response = await patch(
      `/DatosClinicos/comorbilidades?id=${id}`,
      data
    );
    return response.data;
  } catch (error) {
    throw new Error("Error actualizando comorbilidad:", error);
  }
};

const handleDescargarArchivo = async (fileName) => {
  try {
    const response = await get(`/Documentacion/archivo/obtener?archivo=${fileName}`);
    const byteCharacters = atob(response.data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: 'application/octet-stream' });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', fileName);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    console.error("Error descargando archivo:", error);
    message.error("Error al descargar archivo. Por favor, inténtelo de nuevo más tarde.");
  }
};

export {
  get,
  getPatientDemographics,
  getPatientClinicResults,
  getPlanesCuidadoResults,
  getGestoresResults,
  getCitasResults,
  actualizarMedicamento,
  actualizarComorbilidad,
  handleDescargarArchivo
};
